// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles for Mabat3D Portal */

/* CSS Custom Properties (will be overridden by ThemeProvider) */
:root {
  /* Light theme defaults */
  --theme-primary: #48CAE4;
  --theme-primary-hover: #0FA3CC;
  --theme-primary-active: #0B8AAF;
  --theme-background: #FFFFFF;
  --theme-background-secondary: #F8F9FA;
  --theme-background-tertiary: #E9ECEF;
  --theme-surface: #FFFFFF;
  --theme-surface-hover: #F8F9FA;
  --theme-surface-active: #E9ECEF;
  --theme-text-primary: #212529;
  --theme-text-secondary: #6C757D;
  --theme-text-tertiary: #ADB5BD;
  --theme-text-inverse: #FFFFFF;
  --theme-border: #DEE2E6;
  --theme-border-light: #F1F3F4;
  --theme-border-strong: #ADB5BD;
  --theme-success: #28A745;
  --theme-warning: #FFC107;
  --theme-error: #DC3545;
  --theme-info: #17A2B8;
  --theme-shadow: rgba(0, 0, 0, 0.1);
  --theme-shadow-light: rgba(0, 0, 0, 0.05);
  --theme-shadow-strong: rgba(0, 0, 0, 0.15);
}

/* CSS Reset and Base Styles */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  line-height: 1.5;
  color: var(--theme-text-primary, #333);
  background-color: var(--theme-background, #f8f9fa);
  height: 100%;
  overflow: hidden;
  transition: background-color 0.3s ease, color 0.3s ease;
}

#root {
  height: 100vh;
  width: 100vw;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}

h1 { font-size: 2rem; }
h2 { font-size: 1.75rem; }
h3 { font-size: 1.5rem; }
h4 { font-size: 1.25rem; }
h5 { font-size: 1.125rem; }
h6 { font-size: 1rem; }

p {
  margin-bottom: 1rem;
}

a {
  color: #007bff;
  text-decoration: none;
  transition: color 0.2s ease;
}

a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/* Form Elements */
button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  overflow: visible;
  text-transform: none;
}

input, select, textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

input:focus, select:focus, textarea:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Utility Classes */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.text-center { text-align: center; }
.text-left { text-align: start; }
.text-right { text-align: end; }

.d-flex { display: flex; }
.d-none { display: none; }
.d-block { display: block; }

.flex-1 { flex: 1; }
.flex-column { flex-direction: column; }
.align-items-center { align-items: center; }
.justify-content-center { justify-content: center; }
.justify-content-between { justify-content: space-between; }

.mb-0 { margin-bottom: 0; }
.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 1rem; }
.mb-4 { margin-bottom: 1.5rem; }

.p-0 { padding: 0; }
.p-1 { padding: 0.25rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 1rem; }
.p-4 { padding: 1.5rem; }

/* Three-Pane Layout */
.three-pane-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.header-pane {
  flex-shrink: 0;
  height: 70px;
  background: #2c3e50;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  position: relative;
}

.content-area {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.left-menu {
  flex-shrink: 0;
  width: 300px;
  background: #34495e;
  color: white;
  transition: margin-inline-start 0.3s ease;
  overflow-y: auto;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  z-index: 900;
}

.left-menu.collapsed {
  margin-inline-start: -240px;
}

.main-viewer {
  flex: 1;
  position: relative;
  background: #ecf0f1;
  overflow: hidden;
}

/* Move Autodesk ViewCube down to avoid overlapping header controls */
.viewcube-wrapper,
.viewcubeWrapper,
div[class*="viewcube"] {
  top: 20px !important;
}

/* Header Components */
.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
}

.menu-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.menu-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.breadcrumb {
  color: #bdc3c7;
  font-size: 14px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-container {
  position: relative;
  width: 300px;
}

.global-search {
  width: 100%;
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s ease;
}

.global-search:focus {
  background: white;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.user-profile:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #3498db;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* Left Menu Components */
.menu-header {
  padding: 20px;
  border-bottom: 1px solid #2c3e50;
  text-align: center;
}

.menu-user {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}

.menu-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #3498db;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.menu-user-info h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.menu-user-info p {
  margin: 0;
  font-size: 12px;
  color: #95a5a6;
}

.menu-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  display: block;
  padding: 15px 20px;
  color: #ecf0f1;
  text-decoration: none;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #2c3e50;
  color: white;
  text-decoration: none;
}

.menu-item.active {
  background-color: #3498db;
  border-left-color: #2980b9;
  color: white;
}

.menu-item-icon {
  display: inline-block;
  width: 20px;
  margin-right: 12px;
  text-align: center;
}

.menu-item-label {
  font-size: 14px;
  font-weight: 500;
}

/* Scrollbars */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* ESRI Map Overrides */
.esri-view {
  border-radius: 0 !important;
}

.esri-view .esri-view-surface {
  border-radius: 0 !important;
}

/* WebGL Canvas Styling */
canvas {
  outline: none !important;
  border-radius: 0 !important;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

.fade-in {
  animation: fadeIn 0.3s ease;
}

.slide-in {
  animation: slideIn 0.3s ease;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-pane {
    padding: 0 15px;
  }

  .search-container {
    width: 250px;
  }

  .breadcrumb {
    max-width: 300px;
  }

  .left-menu {
    width: 280px;
  }

  .left-menu.collapsed {
    margin-inline-start: -220px;
  }
}

@media (max-width: 768px) {
  .header-pane {
    height: 60px;
    padding: 0 10px;
  }

  .header-center {
    display: none;
  }

  .search-container {
    width: 200px;
  }

  .left-menu {
    width: 260px;
  }

  .left-menu.collapsed {
    margin-inline-start: -200px;
  }

  .menu-header {
    padding: 15px;
  }

  .menu-item {
    padding: 12px 15px;
  }
}

@media (max-width: 480px) {
  .header-right {
    gap: 10px;
  }

  .search-container {
    width: 150px;
  }

  .user-profile .user-name {
    display: none;
  }

  .left-menu {
    width: 240px;
  }

  .left-menu.collapsed {
    margin-inline-start: -180px;
  }
}

/* Dark Theme Support */
@media (prefers-color-scheme: dark) {
  body {
    background-color: #1e1e1e;
    color: #e0e0e0;
  }

  .header-pane {
    background: #1a1a1a;
  }

  .left-menu {
    background: #2d2d2d;
  }

  .main-viewer {
    background: #1e1e1e;
  }

  .menu-item:hover {
    background-color: #3d3d3d;
  }
}

/* Print Styles */
@media print {
  .header-pane,
  .left-menu {
    display: none !important;
  }

  .main-viewer {
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }

  .three-pane-layout {
    overflow: visible !important;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .header-pane {
    background: #000000;
    border-bottom: 2px solid #ffffff;
  }

  .left-menu {
    background: #000000;
    border-right: 2px solid #ffffff;
  }

  .menu-item {
    border-bottom: 1px solid #333333;
  }

  .menu-item:hover,
  .menu-item.active {
    background: #ffffff;
    color: #000000;
  }
}

/* Focus Management for Accessibility */
.focus-visible {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Skip to Content Link */
.skip-to-content {
  position: absolute;
  top: -40px;
  left: 6px;
  background: #007bff;
  color: white;
  padding: 8px;
  border-radius: 4px;
  text-decoration: none;
  z-index: 10000;
  transition: top 0.3s ease;
}

.skip-to-content:focus {
  top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC,gEAAgE;AAChE;EACE,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;;cAEY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,kDAAkD;EAClD,YAAY;EACZ,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,KAAK,eAAe,EAAE;AACtB,KAAK,kBAAkB,EAAE;AACzB,KAAK,iBAAiB,EAAE;AACxB,KAAK,kBAAkB,EAAE;AACzB,KAAK,mBAAmB,EAAE;AAC1B,KAAK,eAAe,EAAE;;AAEtB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe,kBAAkB,EAAE;AACnC,aAAa,iBAAiB,EAAE;AAChC,cAAc,eAAe,EAAE;;AAE/B,UAAU,aAAa,EAAE;AACzB,UAAU,aAAa,EAAE;AACzB,WAAW,cAAc,EAAE;;AAE3B,UAAU,OAAO,EAAE;AACnB,eAAe,sBAAsB,EAAE;AACvC,sBAAsB,mBAAmB,EAAE;AAC3C,0BAA0B,uBAAuB,EAAE;AACnD,2BAA2B,8BAA8B,EAAE;;AAE3D,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;;AAE/B,OAAO,UAAU,EAAE;AACnB,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,OAAO,eAAe,EAAE;;AAExB,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;;;EAGE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV","sourcesContent":["/* Global styles for Mabat3D Portal */\n\n/* CSS Custom Properties (will be overridden by ThemeProvider) */\n:root {\n  /* Light theme defaults */\n  --theme-primary: #48CAE4;\n  --theme-primary-hover: #0FA3CC;\n  --theme-primary-active: #0B8AAF;\n  --theme-background: #FFFFFF;\n  --theme-background-secondary: #F8F9FA;\n  --theme-background-tertiary: #E9ECEF;\n  --theme-surface: #FFFFFF;\n  --theme-surface-hover: #F8F9FA;\n  --theme-surface-active: #E9ECEF;\n  --theme-text-primary: #212529;\n  --theme-text-secondary: #6C757D;\n  --theme-text-tertiary: #ADB5BD;\n  --theme-text-inverse: #FFFFFF;\n  --theme-border: #DEE2E6;\n  --theme-border-light: #F1F3F4;\n  --theme-border-strong: #ADB5BD;\n  --theme-success: #28A745;\n  --theme-warning: #FFC107;\n  --theme-error: #DC3545;\n  --theme-info: #17A2B8;\n  --theme-shadow: rgba(0, 0, 0, 0.1);\n  --theme-shadow-light: rgba(0, 0, 0, 0.05);\n  --theme-shadow-strong: rgba(0, 0, 0, 0.15);\n}\n\n/* CSS Reset and Base Styles */\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 16px;\n  -webkit-text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  line-height: 1.5;\n  color: var(--theme-text-primary, #333);\n  background-color: var(--theme-background, #f8f9fa);\n  height: 100%;\n  overflow: hidden;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n#root {\n  height: 100vh;\n  width: 100vw;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: 1.2;\n  margin-bottom: 0.5rem;\n}\n\nh1 { font-size: 2rem; }\nh2 { font-size: 1.75rem; }\nh3 { font-size: 1.5rem; }\nh4 { font-size: 1.25rem; }\nh5 { font-size: 1.125rem; }\nh6 { font-size: 1rem; }\n\np {\n  margin-bottom: 1rem;\n}\n\na {\n  color: #007bff;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\na:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n/* Form Elements */\nbutton {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  text-transform: none;\n}\n\ninput, select, textarea {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\n\ninput:focus, select:focus, textarea:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n/* Utility Classes */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.text-center { text-align: center; }\n.text-left { text-align: start; }\n.text-right { text-align: end; }\n\n.d-flex { display: flex; }\n.d-none { display: none; }\n.d-block { display: block; }\n\n.flex-1 { flex: 1; }\n.flex-column { flex-direction: column; }\n.align-items-center { align-items: center; }\n.justify-content-center { justify-content: center; }\n.justify-content-between { justify-content: space-between; }\n\n.mb-0 { margin-bottom: 0; }\n.mb-1 { margin-bottom: 0.25rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-3 { margin-bottom: 1rem; }\n.mb-4 { margin-bottom: 1.5rem; }\n\n.p-0 { padding: 0; }\n.p-1 { padding: 0.25rem; }\n.p-2 { padding: 0.5rem; }\n.p-3 { padding: 1rem; }\n.p-4 { padding: 1.5rem; }\n\n/* Three-Pane Layout */\n.three-pane-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.header-pane {\n  flex-shrink: 0;\n  height: 70px;\n  background: #2c3e50;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  position: relative;\n}\n\n.content-area {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.left-menu {\n  flex-shrink: 0;\n  width: 300px;\n  background: #34495e;\n  color: white;\n  transition: margin-inline-start 0.3s ease;\n  overflow-y: auto;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);\n  z-index: 900;\n}\n\n.left-menu.collapsed {\n  margin-inline-start: -240px;\n}\n\n.main-viewer {\n  flex: 1;\n  position: relative;\n  background: #ecf0f1;\n  overflow: hidden;\n}\n\n/* Move Autodesk ViewCube down to avoid overlapping header controls */\n.viewcube-wrapper,\n.viewcubeWrapper,\ndiv[class*=\"viewcube\"] {\n  top: 20px !important;\n}\n\n/* Header Components */\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.header-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.menu-toggle {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.menu-toggle:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.breadcrumb {\n  color: #bdc3c7;\n  font-size: 14px;\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.search-container {\n  position: relative;\n  width: 300px;\n}\n\n.global-search {\n  width: 100%;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #333;\n  font-size: 14px;\n  outline: none;\n  transition: background-color 0.2s ease;\n}\n\n.global-search:focus {\n  background: white;\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.user-profile:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #3498db;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n/* Left Menu Components */\n.menu-header {\n  padding: 20px;\n  border-bottom: 1px solid #2c3e50;\n  text-align: center;\n}\n\n.menu-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 15px;\n}\n\n.menu-user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #3498db;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.menu-user-info h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.menu-user-info p {\n  margin: 0;\n  font-size: 12px;\n  color: #95a5a6;\n}\n\n.menu-items {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menu-item {\n  display: block;\n  padding: 15px 20px;\n  color: #ecf0f1;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  border-left: 3px solid transparent;\n  cursor: pointer;\n}\n\n.menu-item:hover {\n  background-color: #2c3e50;\n  color: white;\n  text-decoration: none;\n}\n\n.menu-item.active {\n  background-color: #3498db;\n  border-left-color: #2980b9;\n  color: white;\n}\n\n.menu-item-icon {\n  display: inline-block;\n  width: 20px;\n  margin-right: 12px;\n  text-align: center;\n}\n\n.menu-item-label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Scrollbars */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n/* ESRI Map Overrides */\n.esri-view {\n  border-radius: 0 !important;\n}\n\n.esri-view .esri-view-surface {\n  border-radius: 0 !important;\n}\n\n/* WebGL Canvas Styling */\ncanvas {\n  outline: none !important;\n  border-radius: 0 !important;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease;\n}\n\n.slide-in {\n  animation: slideIn 0.3s ease;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .header-pane {\n    padding: 0 15px;\n  }\n\n  .search-container {\n    width: 250px;\n  }\n\n  .breadcrumb {\n    max-width: 300px;\n  }\n\n  .left-menu {\n    width: 280px;\n  }\n\n  .left-menu.collapsed {\n    margin-inline-start: -220px;\n  }\n}\n\n@media (max-width: 768px) {\n  .header-pane {\n    height: 60px;\n    padding: 0 10px;\n  }\n\n  .header-center {\n    display: none;\n  }\n\n  .search-container {\n    width: 200px;\n  }\n\n  .left-menu {\n    width: 260px;\n  }\n\n  .left-menu.collapsed {\n    margin-inline-start: -200px;\n  }\n\n  .menu-header {\n    padding: 15px;\n  }\n\n  .menu-item {\n    padding: 12px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-right {\n    gap: 10px;\n  }\n\n  .search-container {\n    width: 150px;\n  }\n\n  .user-profile .user-name {\n    display: none;\n  }\n\n  .left-menu {\n    width: 240px;\n  }\n\n  .left-menu.collapsed {\n    margin-inline-start: -180px;\n  }\n}\n\n/* Dark Theme Support */\n@media (prefers-color-scheme: dark) {\n  body {\n    background-color: #1e1e1e;\n    color: #e0e0e0;\n  }\n\n  .header-pane {\n    background: #1a1a1a;\n  }\n\n  .left-menu {\n    background: #2d2d2d;\n  }\n\n  .main-viewer {\n    background: #1e1e1e;\n  }\n\n  .menu-item:hover {\n    background-color: #3d3d3d;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .header-pane,\n  .left-menu {\n    display: none !important;\n  }\n\n  .main-viewer {\n    margin: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .three-pane-layout {\n    overflow: visible !important;\n  }\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .header-pane {\n    background: #000000;\n    border-bottom: 2px solid #ffffff;\n  }\n\n  .left-menu {\n    background: #000000;\n    border-right: 2px solid #ffffff;\n  }\n\n  .menu-item {\n    border-bottom: 1px solid #333333;\n  }\n\n  .menu-item:hover,\n  .menu-item.active {\n    background: #ffffff;\n    color: #000000;\n  }\n}\n\n/* Focus Management for Accessibility */\n.focus-visible {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n/* Skip to Content Link */\n.skip-to-content {\n  position: absolute;\n  top: -40px;\n  left: 6px;\n  background: #007bff;\n  color: white;\n  padding: 8px;\n  border-radius: 4px;\n  text-decoration: none;\n  z-index: 10000;\n  transition: top 0.3s ease;\n}\n\n.skip-to-content:focus {\n  top: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
